/**
 * The canonical rating policy's bands for a DECLARED rating unit.
 *
 * `divergingBands` is a visual range split: on an even 1-10 scale its high band
 * is 6-10, while canonical favorable share is 8-10. A chart that paints its high
 * band in the favorable colour claims favorable, so when the question declares
 * its unit (`_canonical.unit`, or the matrix measure's `unit`) the bands come
 * from the policy owner (`RATING_POLICIES`, generated from
 * canonical_analysis/rating_statistics.py): unfavorable at or below
 * `unfavorableMaximum`, favorable at or above `favorableMinimum`, the rest
 * neutral. The unit is read, never guessed from the scale; a scale whose bounds
 * disagree with the declared unit gets no policy bands.
 */
import { RATING_POLICIES } from '@digital-twins/shared-types'

import { DivergingBands } from './divergingBands'

export function ratingPolicyBands(
  unit: string | null | undefined,
  scaleMin: number,
  scaleMax: number,
): DivergingBands | null {
  if (!unit) {
    return null
  }
  const policy = RATING_POLICIES[unit]
  if (!policy || policy.minimum !== scaleMin || policy.maximum !== scaleMax) {
    return null
  }
  return {
    statistic: 'favorable_share',
    hasNeutral: policy.favorableMinimum - policy.unfavorableMaximum > 1,
    lowMax: policy.unfavorableMaximum,
    highMin: policy.favorableMinimum,
    scaleMin,
    scaleMax,
  }
}
